import React, { useEffect, useState, useRef } from 'react';


const AnimatedTable = ({ data }) => {
    const [animatedData, setAnimatedData] = useState(data.map(section => ({
        ...section,
        list: [...section.list],
    })));

    const listRefs = useRef([]);

    useEffect(() => {
        const interval = setInterval(() => {
            animatedData.forEach((section, sectionIndex) => {
                const listRef = listRefs.current[sectionIndex];
                if (!listRef) return;

                listRef.style.transition = 'transform 0.5s ease-in-out';
                listRef.style.transform = 'translateY(-40px)';

                setTimeout(() => {
                    const newData = [...animatedData];
                    const currentSection = newData[sectionIndex];
                    const newList = [...currentSection.list];

                    const firstItem = newList.shift(); 
                    newList.push(firstItem); 

                    newData[sectionIndex].list = newList;
                    setAnimatedData(newData);

                   
                    listRef.style.transition = 'none';
                    listRef.style.transform = 'translateY(0)';
                }, 500);
            });
        }, 2000); 

        return () => clearInterval(interval);
    }, [animatedData]);
    return (
        <>
            {/* {data.map((section, sectionIndex) => (
                <div key={sectionIndex} className='w-[calc(100%_-_20px)] m-2.5 border-0 '>
                    <div className='w-full text-[13px] text-white font-extralight tracking-[-0.8px] leading-[55px] h-[55px] bg-contain px-[18px] border-t-[3px] bg-charcoal border-t-aquaBlue'><span>{section.title}</span></div>
                    <div className=''>
                        <ul className='h-[240px] overflow-hidden' >
                            {section.list.map((item, index) => (
                                <li key={index} className='h-10 leading-[40px] text-aquaBlue bg-obsidian odd:bg-black text-[15px] font-bold'>
                                    <div className="flex items-center justify-between">
                                        <div className='ps-10 pe-2.5'>{item.name} </div>
                                        <div className='pe-10 ps-2.5'><strong>{item.amount}</strong></div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            ))} */}
            {animatedData.map((section, sectionIndex) => (
                <div key={sectionIndex} className='w-[calc(100%_-_20px)] m-2.5 border-0 '>
                    <div className='w-full text-xl text-white font-extralight tracking-[-0.8px] leading-[55px] h-[55px] bg-contain px-[18px] border-t-[3px] bg-charcoal border-t-aquaBlue'><span>{section.title}</span></div>
                    <div className='h-[240px] overflow-hidden'>
                        <ul className='transition-transform duration-500 ease-in-out font-Time' ref={el => (listRefs.current[sectionIndex] = el)}>
                            {section.list.map((item, index) => (
                                <li key={index} className='h-10 leading-[40px] text-aquaBlue bg-obsidian odd:bg-black text-[15px] font-bold'>
                                    <div className="flex items-center justify-between">
                                        <div className='ps-10 pe-2.5'>{item.name} </div>
                                        <div className='pe-10 ps-2.5'><strong>{item.amount}</strong></div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            ))}
        </>
    )
}

export default AnimatedTable